export const SET_BUNDLES = "SET_BUNDLES";
export const SET_BUNDLES_ERROR = "SET_BUNDLES_ERROR";
export const SET_BUNDLES_LOADING = "SET_BUNDLES_LOADING";
export const SET_CREATED_BUNDLE = "SET_CREATED_BUNDLE";
export const SET_UPDATED_BUNDLE = "SET_UPDATED_BUNDLE";
export const REMOVE_DELETED_BUNDLE = "REMOVE_DELETED_BUNDLE";
export const SET_BUNDLES_FETCHING = "SET_BUNDLES_FETCHING";
